import { vcoinActions } from '../reducers/vcoins';

export const {
  setSubscriptionPaymentLoading,
  setVcoinPaymentLoading,
} = vcoinActions;
